import React from 'react';

const ContactsUs = () => {
    return (
        <section id="contact-us" className="block spacer p-top-xl p-bottom-xl">
            <div className="wrapper">
                <div className="title text-max-width-2">
                    <h2>Any Questions or Want to Book an Appointment?</h2>
                </div>

                <div className="description text-max-width-2">
                    <p>Your health is very important to us therefore we promise to clear our emails regularly, so you won't be waiting days for a response. If you've sent us a message you'll be sure to get a reply.</p>

                    <p>
                        Phone or text us on <a href="tel:028-851-48965">028 851 48965</a> or email at <a href="mailto:info@botanyphysio.co.nz">info@botanyphysio.co.nz</a>
                    </p>

                    <p>
                        Follow us on Instagram to stay up to date: <a href='https://www.instagram.com/botanyphysiotherapy/'>@botanyphysiotherapy</a>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default ContactsUs;
